<template>
  <div class="row_media_media">
    <article class="item" style="">
      <header>
        <div :class="'row_media_header _' + item.mediaId">
          <img :src="item.src" alt="" />
          <h3>
            <a :href="'category/' + item.mediaId + '.html'" target="_blank">{{
              item.cateTitle
            }}</a>
          </h3>
        </div>
      </header>
      <div class="row_cont">
        <ul class="ul_news" v-for="(list, index) in item.list" :key="index">
          <li>
            <a :href="'category/' + list[1] + '.html#' + list[4]">
              <span class="list_rank color_gold">{{ list[3] }}</span>
              <span class="list_rank_juni">位</span>
              <p>{{ list[8] }}</p>
            </a>
          </li>
        </ul>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* -----------
white-block
------------ */

.content {
  margin: 0 auto;
  display: flex;
  height: 650px;
  box-sizing: border-box;
  max-width: 800px;
}
.content_l {
  width: 193px;
  display: flex;
  flex-wrap: wrap;
}
.content_l img {
  width: 100%;
  max-width: 193px;
  max-height: 193px;
  object-fit: contain;
}
.magazineDescription {
  font-size: 14px;
  height: 436px;
  margin: 0 0 0 auto;
  padding: 17px 0 0;
  overflow: auto;
}
.content_r {
  max-width: 65px;
  display: block;
  text-align: center;
  margin: 0 0 0 20px;
}
.crownsize {
  font-size: 46px;
}
.magazineTitle,
.top5rank {
  font-size: 20px;
  width: 100%;
}
.magazineTitle {
  text-align: center;
  width: 27px;
  margin: 0 auto;
  height: 530px;
  text-align: left;
}
.top5rank {
  font-size: 47px;
}
.vertical {
  writing-mode: vertical-rl;
}
.color_gold {
  color: #d2ac31;
}
.box1 {
  order: 1;
}
.box2 {
  order: 2;
}
.box3 {
  order: 3;
}
.box4 {
  order: 4;
}
.box5 {
  order: 5;
}
.white-block__container {
  max-width: 1200px;
  /* width: 95%; */
  background: #fff;
}
span.list_rank,
span.list_rank_juni {
  font-size: 39px;
  font-weight: bold;
  font-family: 'futura-pt', futura, 'Century Gothic', 游ゴシック体, YuGothic,
    'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 游ゴシック, 'Yu Gothic',
    メイリオ, Meiryo, sans-serif;
  font-style: italic;
  font-weight: 700;
}
.list_rank {
  font-size: 34px;
  display: inline;
  font-style: italic;
  word-break: normal;
}

span.list_rank_juni {
  font-size: 14px;
  margin-right: 20px;
  margin-left: 0;
  margin-top: 10px;
  display: block;
  /* margin: 0; */
  padding: 0;
}

span.list_rank_title {
  display: block;
}
</style>
